import { Page } from '@markant-platform/shared/data-access';
import {
  BookingOrganization,
  BookingUserDetails,
  PriceRequestOrganizationAdminData,
  PriceRequestServiceAdminData,
} from '@markant-platform/shared/backoffice/model';
import { OrganizationType, QualificationLevel } from 'data-model';

export const MOCK_PRICE_REQUEST_ORGANIZATION_DATA: BookingOrganization = {
  customerNumber: '12345',
  organizationId: 'org-id',
  organizationType: OrganizationType.DEALER,
  name: 'Adesso SE',
  gln: '1234567890123',
  address: {
    street: 'TestStr.',
    streetNumber: '123',
    zipCode: '12345',
    city: 'Berlin',
    countryCode: 'DE',
  },
  ezrCustomer: false,
  qualificationLevel: QualificationLevel.LEVEL_3,
};

export const MOCK_PRICE_REQUESTS: Page<PriceRequestOrganizationAdminData | PriceRequestServiceAdminData> = {
  result: [
    {
      id: 'test-price-request-1',
      requestDate: '2023-09-15T15:09:36.020Z',
      offerNumber: '123456',
      requesterName: 'Sebastian Egger',
      cartridge: {
        cartridgeId: '64832f78011bd3056728d263',
        cartridgeVariantId: '64832f78011bd3056728d261',
        cartridgeName: 'Leistungscontainer',
        cartridgeVariantName: 'Counter Cartridge Variant 12',
      },
      offerPrice: {
        billingPeriod: 'MONTHLY',
        currency: 'EUR',
        priceModel: 'SUBSCRIPTION',
      },
      user: {} as BookingUserDetails,
      organization: {
        customerNumber: '123abc',
        name: 'First GmbH',
        organizationType: 'DEALER',
      } as BookingOrganization,
      state: 'OPEN',
      lastModifiedAt: '2023-09-20T15:09:36.020Z',
      comments: [],
      version: 1,
    },
    {
      id: 'test-price-request-2',
      requestDate: '2023-09-16T15:09:36.020Z',
      offerNumber: '78910',
      requesterName: 'Lisa Eberhardt',
      cartridge: {
        cartridgeId: '64832f7d011bd3056728d267',
        cartridgeVariantId: '64832f7d011bd3056728d266',
        cartridgeName: 'SharePlace',
        cartridgeVariantName: 'SharePlace',
      },
      offerPrice: {
        billingPeriod: 'MONTHLY',
        currency: 'EUR',
        priceModel: 'SUBSCRIPTION',
      },
      user: {} as BookingUserDetails,
      organization: {
        customerNumber: '123def',
        name: 'Second GmbH',
        organizationType: 'DEALER',
      } as BookingOrganization,
      state: 'ACCEPTED',
      lastModifiedAt: '2023-09-24T15:09:36.020Z',
      comments: [],
      version: 1,
    },
    {
      id: 'test-price-request-3',
      requestDate: '2023-09-17T15:09:36.020Z',
      offerNumber: '111213',
      requesterName: 'Sebastian Egger',
      cartridge: {
        cartridgeId: '64ad3cac479b6b0073e50fe6',
        cartridgeVariantId: '64ad3cac479b6b0073e50fe3',
        cartridgeName: 'See Leistung',
        cartridgeVariantName: 'Walchensee Variante 1',
      },
      offerPrice: {
        billingPeriod: 'MONTHLY',
        currency: 'EUR',
        priceModel: 'SUBSCRIPTION',
      },
      user: {} as BookingUserDetails,
      organization: {
        customerNumber: '123def',
        name: 'Third GmbH',
        organizationType: 'SUPPLIER',
      } as BookingOrganization,
      state: 'OFFER_SENT',
      lastModifiedAt: '2023-09-22T15:09:36.020Z',
      comments: [],
      version: 1,
    },
  ],
  hasNext: false,
  pageIndex: 1,
  pageSize: 10,
  totalCount: 3,
};

export const MOCK_PRICE_REQUEST_SERVICE_ADMIN_DATA: PriceRequestServiceAdminData = {
  ...(MOCK_PRICE_REQUESTS.result[0] as PriceRequestServiceAdminData),
  user: {
    firstname: 'Test',
    lastname: 'User',
    email: 'test.user@test.com',
    phone: '0120304005',
  } as BookingUserDetails,
  organization: MOCK_PRICE_REQUEST_ORGANIZATION_DATA,
};

export const MOCK_PRICE_REQUEST_ORGANIZATION_ADMIN_DATA: PriceRequestOrganizationAdminData = {
  ...(MOCK_PRICE_REQUESTS.result[0] as PriceRequestOrganizationAdminData),
};
